module.exports = __webpack_public_path__ + "static/media/siddharth-chikmagalur-trip-09.fb057d2f.png";